import { Component, OnInit } from "@angular/core";
import { ExtrasService } from "src/app/extras.service";
import { LatLngBounds } from "@agm/core";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";

declare var google: any;

@Component({
  selector: "app-area-search",
  templateUrl: "./area-search.component.html",
  styleUrls: ["./area-search.component.scss"],
})
export class AreaSearchComponent implements OnInit {
  query: string;
  featureCollection: any = [];
  map: any; // Reference alla mappa vera e propria
  selectedAreaGeoJson: any;
  bounds: LatLngBounds;
  loading: boolean = false;

  constructor(
    public extrasService: ExtrasService,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {}

  searchArea() {
    this.loading = true;
    this.extrasService.findAreaService(this.query).subscribe(
      (response) => {
        this.loading = false;
        this.featureCollection = response;
        //this.adjustBounds();
      },
      (err) => {
        this.genericErrorModalService.open(
          "Errore nella ricerca dell'area",
          err
        );
      }
    );
  }

  onItemClick(feature) {
    this.selectedAreaGeoJson = feature;
    this.adjustBounds(feature.geometry);
  }

  styleFunc(feature) {
    return {
      clickable: false,
      // fillColor: feature.getProperty('color'),
      fillColor: "rgba(0, 0, 0, 0.486)",
      strokeColor: "rgba(0, 0, 0, 0.400)",
      strokeWeight: 1,
    };
  }

  onMapReady(map) {
    this.map = map;
    map.setOptions({ draggable: true, fullscreenControl: true });
  }

  adjustBounds(geometry) {
    this.bounds = new google.maps.LatLngBounds();
    if (geometry.type == "Polygon") {
      for (const mm of geometry.coordinates[0]) {
        this.bounds.extend(new google.maps.LatLng(mm[1], mm[0]));
      }
      this.map.fitBounds(this.bounds);
    } else if (geometry.type == "MultiPolygon") {
      for (const polygon of geometry.coordinates) {
        for (const mm of polygon[0]) {
          this.bounds.extend(new google.maps.LatLng(mm[1], mm[0]));
        }
      }
      this.map.fitBounds(this.bounds);
    }
  }
}
